import React, { useState } from 'react';
import { Link, usePage } from '@inertiajs/react';
import { Sheet, SheetContent } from '../../ui/sheet';

function MenuItems({ items, onItemClick }) {
    return items.map((item, index) => {
        const Tag = item.inertia ? Link : 'a';
        const className = `group relative block cursor-pointer p-4 text-[14px] font-bold uppercase transition-colors ${
            item.active
                ? 'bg-[#ffd400] text-[#003545]'
                : 'text-[#808080] hover:bg-[#ffd400] hover:text-[#003545]'
        }`;

        return (
            <Tag
                key={index}
                href={item.permalink || '#'}
                className={className}
                onClick={onItemClick}
            >
                {item.glyph && (
                    <span className="inline-block w-12 h-[22px] align-middle text-center overflow-visible">
                        <svg className="inline h-[22px] w-[22px] align-middle fill-[#003545] relative -top-px" role="img">
                            <use href={`#${item.glyph}`}></use>
                        </svg>
                    </span>
                )}
                <span className="align-baseline">{item.title}</span>
            </Tag>
        );
    });
}

export default function Sidebar({ mobileOpen = false, onMobileClose }) {
    const { mainmenu } = usePage().props;
    const [compact, setCompact] = useState(() => JSON.parse(localStorage.getItem('menu.collapsed')) === true);
    const items = mainmenu || [];

    function toggle() {
        const next = !compact;
        setCompact(next);
        localStorage.setItem('menu.collapsed', JSON.stringify(next));
    }

    return (
        <>
            {/* Desktop sidebar */}
            <aside className={`hidden shrink-0 bg-white lg:block overflow-visible relative z-20 ${compact ? 'sidebar--compact' : ''}`}>
                <nav className="sticky top-0 flex flex-col min-w-[253px] max-h-screen overflow-visible">
                    <button
                        onClick={toggle}
                        className="absolute -right-3.5 top-10 z-10 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-[#003545] text-white shadow-md hover:scale-[1.2] transition-all duration-100 ease-in-out"
                    >
                        <svg className={`h-3.5 w-3.5 transition-transform ${compact ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <div className={`flex flex-col ${compact ? '' : 'overflow-y-auto'} max-h-screen`}>
                        <MenuItems items={items} />
                        {compact && items.map((item, index) => (
                            <span key={`tooltip-${index}`} className="pointer-events-none absolute left-full top-1/2 z-[400] ml-2.5 -translate-y-1/2 whitespace-nowrap rounded-[3px] bg-[#003545] p-2 text-[10px] font-bold uppercase text-white shadow-[0_3px_6px_rgba(0,0,0,0.16),0_3px_6px_rgba(0,0,0,0.17)] opacity-0 transition-opacity group-hover:opacity-100">
                                {item.title}
                            </span>
                        ))}
                    </div>
                </nav>
            </aside>

            {/* Mobile sidebar */}
            <Sheet open={mobileOpen} onOpenChange={(open) => !open && onMobileClose?.()}>
                <SheetContent side="left" className="w-[253px] p-0 bg-white [&>button]:hidden">
                    <div className="flex flex-col overflow-y-auto h-full pt-4">
                        <MenuItems items={items} onItemClick={onMobileClose} />
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
}
